export default {
  operation: "create",
  instanceCreateLoading: false,
  instanceCopyLoading: false,
  instanceEditLoading: false,
  blogComponentAttrs: [],
  blogSelectedInstance: [],
  blogComponentLoading: [],
  blogComponentInstances: {},
  blogComponentInstancesLoading: {},
  error: "",
  success: ""
};
